<template>
  <div>
    <rp-messages
      ref="messages"
      :authUser="authUser"
      :results="getData"
      :messageType="messageType"
      :selectedMessage="selectedMessage"
      :overlayActive="showMessage"
      @updateSortBy="updateSortBy"
      @deleteMessage="deleteMessage"
      @archiveMessage="archiveMessage"
      @openMessage="openMessage"
      @closeMessage="closeMessage" />

    <rp-overlay :active="deleteActive">
      <rp-alert
        icon="done"
        :message="successDeleteMessage"
        :onClick="successDeleteFunction">
      </rp-alert>
    </rp-overlay>

    <rp-overlay :active="archiveActive">
      <rp-alert
        icon="done"
        :message="successArchiveMessage"
        :onClick="successArchiveFunction">
      </rp-alert>
    </rp-overlay>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {getMessages, getSentMessages, deleteMessage, archiveMessage, getMessage} from 'raypro_ui/src/api/messages'

  import Messages from 'raypro_ui/src/components/ui/Messages'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert'
  import page from '@/mixins/page'

  export default {
    name: 'messages',

    components: {
      'rp-messages': Messages,
      'rp-overlay': Overlay,
      'rp-alert': Alert
    },

    data() {
      return {
        show: false,
        sortBy: '',
        messages: [],
        deleteActive: false,
        archiveActive: false,
        successDeleteMessage: 'Message successfully deleted',
        successArchiveMessage: 'Message archive updated!',
        title: 'Messages',
        selectedMessage: {},
        showMessage: false
      }
    },

    props: {messageType: String},

    mixins: [page],

    computed: {
      ...mapGetters(['authUser']),

      userId() {
        return this.authUser.id
      },

      params() {
        const params = []

        if(this.$route.query.important) {
          params.push('important=true')
        }

        if(this.$route.query.archived) {
          params.push('archived=true')
        }

        if(this.sortBy) {
          params.push(`sort_direction=${this.sortBy}`)
        }

        return params
      }

    },

    mounted() {
      this.getData()
    },

    methods: {
      ...mapActions(['checkUnreadMessage']),

      successDeleteFunction() {
        this.deleteActive = false
        this.$router.go()
      },

      successArchiveFunction() {
        this.archiveActive = false
        this.$router.go()
      },

      getData(p) {
        let promise

        if(this.messageType === 'outbox') {
          promise = getSentMessages(p, this.params)
        } else {
          promise = getMessages(p, this.userId, this.params)
        }

        return promise.then(({data, page}) => {
          return {
            data,
            page
          }
        })
      },

      archiveMessage(id, data) {
        const messages = this.$refs.messages

        archiveMessage(this.userId, id, data)
          .then(() => {
            this.archiveActive = true
            messages.hideMessage()
          })
      },

      deleteMessage(id) {
        const messages = this.$refs.messages

        deleteMessage(this.userId, id).then(() => {
          this.deleteActive = true
          messages.hideMessage()
        })
      },

      openMessage(message) {
        getMessage(this.userId, message.id).then((response) => {
          this.selectedMessage = response.data
          message.read_at = ''
          this.showMessage = true
          this.checkUnreadMessage()
        })
      },

      closeMessage() {
        this.showMessage = false
      },

      updateSortBy(sortBy) {
        this.sortBy = sortBy
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Messages/Messages.vue